import React from "react";
import { useTheme } from "../../context/ThemeContext";

type BrandLogoVariant = "auto" | "dark" | "light";

interface BrandLogoProps {
  height?: number;
  variant?: BrandLogoVariant; // auto uses theme
  className?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ height = 28, variant = "auto", className }) => {
  const { theme } = useTheme();
  const isDarkTheme = theme === "dark";
  const resolvedVariant: "dark" | "light" = variant === "auto" ? (isDarkTheme ? "light" : "dark") : (variant as any);

  const src = resolvedVariant === "light"
    ? "/meylo-logo-white.svg"
    : "/meylo-logo-dark.svg";

  return (
    <img
      src={src}
      alt="Meylo"
      height={height}
      className={className}
      style={{ display: "block" }}
    />
  );
};

export default BrandLogo;




